import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';

var _templateObject;
var getOpacity = function getOpacity(_ref) {
  var $finished = _ref.$finished;
  return $finished ? '0' : '1';
};
var getBackground = function getBackground(_ref2) {
  var theme = _ref2.theme;
  return theme.colours.canvas.secondary.main;
};
var RootSVG = styled.svg(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background: ", ";\n  opacity: ", ";\n  transition-property: opacity;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: ", ";\n"])), getBackground, getOpacity, function (_ref3) {
  var $transitionDuration = _ref3.$transitionDuration;
  return $transitionDuration;
});

export { RootSVG as default };
//# sourceMappingURL=Loader.styles.js.map
